<div class="form-group mt-3 fill-dark-blue">This months referrals converted to account</div>
<ng-table [rows]="rows" [columns]="columns" ></ng-table>